// 归档生效判断
export default class ArchiveEffectUtils {
  constructor() {

  }

  /**
   * 归档生效判断
   */
  static checkArchiveEffect(job, action) {
    if (!job) return false
    // 未归档
    if (job.pigeonhole) return true
    return false
  }
}
